/**
 * Valores monetários da API em centavos (ex.: 10000 → R$ 100,00).
 * @param {number|string|null|undefined} cents
 * @param {string|{ fallback?: string, currency?: string }} [options] fallback ou opções
 */
export function formatCurrencyFromCents(cents, options = '-') {
  const opts = typeof options === 'string' ? { fallback: options } : { fallback: '-', ...options };
  const { fallback = '-', currency = 'BRL' } = opts;

  if (cents == null || cents === '') return fallback;
  const n = Number(cents);
  if (Number.isNaN(n)) return fallback;
  return (n / 100).toLocaleString('pt-BR', {
    style: 'currency',
    currency,
  });
}

/** Alias usado em telas de fatura / financeiro super-admin. */
export const formatInvoiceCurrency = formatCurrencyFromCents;

/**
 * Máscara ATM para inputs de valor monetário.
 * Os dígitos do valor exibido correspondem a centavos — ex.: digitar "150" → "R$ 1,50"; "15000" → "R$ 150,00".
 * Compatível com o padrão do projeto (ContactModal).
 * Para salvar, extraia os dígitos: Number(value.replace(/\D/g, '')) === centavos.
 */
export function formatCurrencyInput(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) return '';
  return (Number(digits) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}
